import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { CmsService, TranslatePipe } from '@spartacus/core';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { MyaccountB2bunitService } from 'src/app/service/myaccount/myaccount-b2bunit.service';
import {
  EDIT_ACCOUNT_INFO,
  MyaccountFeaturesConfigService,
} from 'src/app/service/myaccount/myaccount-features-config.service';
import { MyaccountInfoService } from 'src/app/service/myaccount/myaccount-info.service';
import { MyaccountPersonalInfoService } from 'src/app/service/myaccount/myaccount-personal-info.service';
import { FREIGHT, SnahCountryService } from 'src/app/service/snah/snah-countries.service';
import { TooltipTextComponent } from '../../tooltip-text/tooltip-text.component';

@Component({
  selector: 'app-myaccount-account-info',
  templateUrl: './myaccount-account-info.component.html',
  styleUrls: ['./myaccount-account-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, RouterLink, TooltipTextComponent, MatIcon, AsyncPipe, TranslatePipe],
})
export class MyaccountAccountInfoComponent implements OnInit {
  myaccountAccountInfo$: Observable<any>;
  myaccountAccountInfoLoaded$: Subscription;
  myaccountAccountUserInfo$: Subscription;
  freightLevelSubsciption$: Subscription;
  freightPrice = '$0';

  activeCountry$: Observable<string> = this.countryService.getActive();

  isEditAccountInfoEnabled$: Observable<any> = this.activeCountry$.pipe(
    take(1),
    switchMap((activeCountry) =>
      this.myaccountFeaturesConfigSerivce.isMyaccountFeatureEnabled$(activeCountry, EDIT_ACCOUNT_INFO)
    )
  );
  showActiveSnahCountry$: Observable<boolean> = this.SnahCountryService.getSnahFeatures(FREIGHT);

  constructor(
    protected cms: CmsService,
    private myaccountInfo: MyaccountInfoService,
    private countryService: ShimanoCountryService,
    private myaccountFeaturesConfigSerivce: MyaccountFeaturesConfigService,
    private myAccountB2B: MyaccountB2bunitService,
    private cdr: ChangeDetectorRef,
    private componentService: ComponentService,
    private SnahCountryService: SnahCountryService,
    private myaccountPersonalInfoService: MyaccountPersonalInfoService
  ) {}

  ngOnInit() {
    this.myaccountAccountInfoLoaded$ = combineLatest([
      this.isAccountPage$(),
      this.getMyAccountInfo(),
      this.myAccountB2B.isPaymentDetailsLoaded,
    ]).subscribe(([isAccountPage, myAccountInfo, isPaymentDetailsLoaded]) => {
      if (isAccountPage && myAccountInfo && isPaymentDetailsLoaded) {
        this.myaccountAccountInfo$ = of(myAccountInfo);
        this.myaccountInfo.isMyAccountInfoDetailsLoaded.next(true);
      }

      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
    this.freightLevelSubsciption$ = this.componentService.freightLevel$.subscribe((data) => {
      this.freightPrice = data;
      this.cdr.detectChanges();
    });
  }

  private getMyAccountInfo(): Observable<any> {
    return this.myaccountInfo.getMyAccountInfo();
  }

  isAccountPage$(): Observable<boolean> {
    return this.cms
      .getCurrentPage()
      .pipe(map((currentPage) => currentPage && currentPage.label.includes('/my-account')));
  }

  showAddress(addresses: any): Observable<string> {
    return this.myaccountPersonalInfoService.formatAddress(addresses);
  }

  ngOnDestroy() {
    if (this.myaccountAccountInfoLoaded$) {
      this.myaccountAccountInfoLoaded$.unsubscribe();
    }
  }
}
